var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: {
        visible: _vm.visible,
        persistent: _vm.persistent,
        fullscreen: _vm.fullscreen,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "elevation-24" },
        [
          _vm.warning_banner
            ? _c(
                "v-banner",
                { attrs: { icon: "mdi-alert", color: "warning" } },
                [_vm._v(" " + _vm._s(_vm.warning_banner) + " ")]
              )
            : _vm._e(),
          _c(
            "v-tabs",
            {
              staticClass: "left-justify-tabs",
              attrs: {
                vertical: "",
                value: _vm.activeTab,
                color: "primary-visible",
                "show-arrows": "",
              },
              on: { change: _vm.selected_tab },
            },
            [
              _c(
                "v-tab",
                { attrs: { id: "select-tab-local", href: "#uploadtab-local" } },
                [_vm._v("Local Files")]
              ),
              _vm.serverMode
                ? _c(
                    "v-tab",
                    {
                      attrs: {
                        id: "select-tab-database",
                        href: "#uploadtab-database",
                      },
                    },
                    [_vm._v("Database")]
                  )
                : _vm._e(),
              _c(
                "v-tab",
                { attrs: { id: "select-tab-s3", href: "#uploadtab-s3" } },
                [_vm._v("S3 Bucket")]
              ),
              _c(
                "v-tab",
                {
                  attrs: { id: "select-tab-splunk", href: "#uploadtab-splunk" },
                },
                [_vm._v("Splunk")]
              ),
              _c(
                "v-tab",
                {
                  attrs: {
                    id: "select-tab-tenable",
                    href: "#uploadtab-tenable",
                  },
                },
                [_vm._v(" Tenable.SC ")]
              ),
              _c("v-spacer"),
              _c("v-divider"),
              _c(
                "v-tab",
                {
                  attrs: { id: "select-tab-sample", href: "#uploadtab-sample" },
                },
                [_vm._v("Samples")]
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "uploadtab-local" } },
                [_c("FileReader", { on: { "got-files": _vm.got_files } })],
                1
              ),
              _vm.serverMode
                ? _c(
                    "v-tab-item",
                    { attrs: { value: "uploadtab-database" } },
                    [
                      _c("DatabaseReader", {
                        attrs: { refresh: _vm.visible },
                        on: { "got-files": _vm.got_files },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-tab-item",
                { attrs: { value: "uploadtab-sample" } },
                [_c("SampleList", { on: { "got-files": _vm.got_files } })],
                1
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "uploadtab-s3" } },
                [_c("S3Reader", { on: { "got-files": _vm.got_files } })],
                1
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "uploadtab-splunk" } },
                [_c("SplunkReader", { on: { "got-files": _vm.got_files } })],
                1
              ),
              _c(
                "v-tab-item",
                { attrs: { value: "uploadtab-tenable" } },
                [_c("TenableReader", { on: { "got-files": _vm.got_files } })],
                1
              ),
            ],
            1
          ),
          _c("HelpFooter"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }